import React, { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import TextField from "../components/fields/TextField";
import SearchField from "../components/fields/SearchField";
import { AlterIcon, BrainIcon, StethoscopeIcon, StretcherIcon } from "../components/Icons";
import "react-credit-cards/es/styles-compiled.css";
import ButtonCategory from "../components/buttons/ButtonCategory";
import styled from "styled-components";
import { SubTitle, Title } from "../components/Titles";
import CardMySchedules from "../components/cards/CardMySchedules/CardMySchedules";

const QuickSearchArea = styled.div`
	padding-left: 25px;
	padding-right: 25px;
`;

const MeusAtendimentosArea = styled.div`
	padding-left: 25px;
	padding-right: 25px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: stretch;
	align-content: space-between;
`;

const PendentesWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	align-content: center;
	padding: 10px;
	gap: 5px;
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 165.5%;
	color: #002b49;
`;

const IconGreenAvatar = styled.div`
	width: 27px;
	height: 25px;
	background: ${props => props.theme.colors.primary};
	border-radius: 25px;
	font-family: Livvic;
	font-style: normal;
	font-weight: 600;
	font-size: 20px;
	text-align: center;
	color: #002b49;
	padding-top: 2px;
`;

/**
 * ### Tela de testes
 * Utilizado para testar componentes em desenvolvimento sem atrapalhar a estrutura das telas ja esxistentes
 */
const TestsScreen: FC = () => {
	const { token } = useParams<{ token: string }>();
	useEffect(() => {
		window.sessionStorage.setItem("token", token ? token : "null");
	}, [token]);

	return (
		<div>
			{/* <Button>Teste</Button>
            <InfoIcon size={50} color="#000000" />
            <TextField placeholder="Teste" />
            <InputMask
                mask='999.999.999-99'
                placeholder='Cpf'>
                {(inputProps: any) => <TextField {...inputProps} />}
            </InputMask>
            <InputMask
                mask='99/99/9999'
                placeholder='Data nascimento'>
                {(inputProps: any) => <TextField {...inputProps} />}
            </InputMask>
            <Cards
                cvc={123}
                expiry={"10/20"}
                focused={"name"}
                name={"ALan Henrique Jahnel"}
                number={4349377027705940}
                locale={{
                    valid: 'Validade'
                }}
            /> */}
			{/* <InputMask mask='99/99/9999' placeholder='Data nascimento'>
				{(inputProps: any) => <TextField {...inputProps} />}
			</InputMask> */}
			<div style={{ width: "100%", height: "30px" }} /> {/*Espaçamento*/}
			<Title>Novos agendamentos</Title>
			<QuickSearchArea>
				<SearchField
					placeholder="digite “Veganismo”"
					onChange={event => {
						console.log(event.target.value);
					}}
				/>
			</QuickSearchArea>
			<SubTitle>Busca rápida</SubTitle>
			<QuickSearchArea>
				<ButtonCategory
					style={{
						width: "50%",
						float: "left",
					}}
					icon={<StretcherIcon size={20} color="#000000" />}
					label="Nutricionista"
				/>
				<ButtonCategory
					style={{
						width: "50%",
						float: "left",
					}}
					icon={<AlterIcon size={20} color="#000000" />}
					label="Personal Trainer"
				/>
				<ButtonCategory
					style={{
						width: "50%",
						float: "left",
					}}
					icon={<BrainIcon size={20} color="#000000" />}
					label="Psicólogo"
				/>
			</QuickSearchArea>
			<div style={{ width: "100%", height: "90px" }} /> {/*Espaçamento*/}
			<SubTitle>Meus Agendamentos</SubTitle>
		</div>
	);
};

export default TestsScreen;
